import { Component, OnInit, inject, signal } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { LimitedTimeEvent } from '@app/shared/models/limitedTimeEvent.model';
import { Modal, ModalConfig, ModalType, NonPersistedModalName } from '@app/shared/models/modal.model';
import { LoggerService } from '@app/shared/services/logger.service';
import { EventManager } from '@app/shared/utils/event-manager';
import { ButtonComponent } from '@app/shared/components/button/button.component';
import { SharedModule } from '@app/shared/shared.module';
import { NavigationButtonComponent } from '@app/shared/components/navigation-button/navigation-button.component';
import { EventsRepository } from '@app/shared/state/events/events.repository';

@Component({
  selector: 'slotcom-progressbag-progress-modal',
  templateUrl: './progressbag-progress.component.html',
  styleUrls: ['./progressbag-progress.component.scss'],
  standalone: true,
  imports: [SharedModule, ButtonComponent, NavigationButtonComponent],
})
export class ProgressbagProgressModalComponent implements OnInit {
  protected readonly progressbagProgressModalData = inject<ModalConfig>(MAT_DIALOG_DATA);
  private eventManager = inject(EventManager);
  public logger = inject(LoggerService);
  private eventsRepo = inject(EventsRepository);

  event = signal<LimitedTimeEvent | null>(null);

  ngOnInit(): void {
    const evt = this.eventsRepo.getEventById(this.progressbagProgressModalData.properties.eventId);

    this.event.set(evt);
  }

  closeModal(): void {
    this.eventManager.closeModal(
      new Modal(this.progressbagProgressModalData.id, ModalType.Persisted, this.progressbagProgressModalData)
    );
  }

  openProgressbag(): void {
    if (
      this.eventsRepo.hasEvent(this.progressbagProgressModalData.properties.eventId) &&
      this.progressbagProgressModalData.properties.finished !== true
    ) {
      this.eventManager.openModal(
        new Modal(NonPersistedModalName.ProgressbagModalComponent, ModalType.View, {
          modal: this.progressbagProgressModalData,
          animated: false,
        })
      );
    }

    this.closeModal();
  }
}
